import { FC } from 'react';
import Image from 'next/image';
import { getNextApiUrl } from '@/utils/next-api';
import { Link } from '@/components/Link';
import { LoginButtonLink, RegisterButtonLink } from '../components/ButtonLinks';
import styles from '../styles/animation.module.css';

const MainAuthPage: FC = () => {
  return (
    <main className="!absolute flex flex-1 flex-col items-center page-full">
      <div
        className={`${styles['slide-in-fwd-bottom']} z-0
                          -mb-5 flex h-full w-full max-w-[1300px] flex-1 items-start
                          justify-center bg-[url('https://s3.ir-thr-at1.arvanstorage.com/mofidapp/splash/splash-auth.webp')] bg-cover bg-bottom
                          bg-no-repeat
                          py-6 ![animation-delay:0.5s] md:!mb-0 md:bg-contain`}
      >
        <div className={`${styles['slide-in-left']} ![animation-delay:1s]`}>
          <Image
            alt="کارگزاری مفید، پیشرفت مداوم"
            height={70}
            src="https://s3.ir-thr-at1.arvanstorage.com/mofidapp/common/logo-col.svg"
            width={120}
            priority
          />
        </div>
      </div>

      <div className="z-10 !mt-auto flex w-full max-w-[472px] flex-col gap-y-3 bg-[#fff] px-5 pb-4 children:w-full">
        <LoginButtonLink />
        <RegisterButtonLink />
        <Link
          analytics={['AUTH_PRIVACY_POLICY']}
          className="mt-2 text-center text-xs font-medium text-blue-30"
          href={getNextApiUrl('privacy')}
          id="auth_click_privacyPolicy"
          target="_blank"
        >
          خط مشی حریم شخصی
        </Link>
      </div>
    </main>
  );
};

export default MainAuthPage;
